import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';
import { api } from '../api.js';
import { formatEur } from '@csoki/shared';
import { Catalog } from './Catalog.js';
import { useKioskWs } from '../hooks/useKioskWs.js';

export function Kiosk() {
  const state = useKioskWs('main');

  if (state.kind === 'pending') {
    return <KioskPayment purchase={state.current} />;
  }

  return (
    <div className="kiosk">
      {state.kind === 'connecting' && (
        <div className="reconnecting">Reconnecting…</div>
      )}
      <Catalog kioskMode />
    </div>
  );
}

function KioskPayment({
  purchase,
}: {
  purchase: import('@csoki/shared').PendingPurchase;
}) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    QRCode.toCanvas(canvasRef.current, purchase.epcQrPayload, {
      errorCorrectionLevel: 'M',
      margin: 2,
      width: 360,
    }).catch(() => {});
  }, [purchase.epcQrPayload]);

  async function confirm() {
    try {
      await api('POST', `/api/purchases/${purchase.id}/confirm`);
    } catch (e) {
      alert((e as Error).message);
    }
  }
  async function cancel() {
    try {
      await api('POST', `/api/purchases/${purchase.id}/cancel`);
    } catch (e) {
      alert((e as Error).message);
    }
  }

  return (
    <div className="kiosk-payment">
      <h1>Scan to pay</h1>
      <div className="payment-meta">
        <div className="line">{purchase.quantity}× {purchase.productName}</div>
        <div className="amount">{formatEur(purchase.totalCents)}</div>
        <div className="seller">to {purchase.sellerFullName}</div>
        <div className="code">Ref: {purchase.referenceCode}</div>
      </div>
      <canvas ref={canvasRef} />
      <p className="hint">
        Scan this code in your banking app (not the regular camera). Your bank should
        pre-fill the recipient and amount.
      </p>
      <div className="row">
        <button onClick={cancel} className="danger">
          Cancel
        </button>
        <button onClick={confirm}>OK — I paid</button>
      </div>
    </div>
  );
}
